import axios from '../../config/axios-interceptor';
import i18n from '../../i18n';

export const REGISTER = '[REGISTER] REGISTER';
export const REGISTER_SUCCESS = '[REGISTER] REGISTER_SUCCESS';
export const REGISTER_FAIL = '[REGISTER] REGISTER_FAIL';

export const handleRegister = (body) => {
  return async dispatch => {
    dispatch({ type: REGISTER });

    try {
        const getLanguage = localStorage.getItem('language')
        
        const response = await axios.post('Account/register', body, {
          headers: {
            'Accept-Language': getLanguage
          }
        });
  
        if (response?.data?.succeeded) {
          dispatch({ type: REGISTER_SUCCESS, payload: response.data.message });
        } else {
          dispatch({ type: REGISTER_FAIL, payload: response.data.message });
        }
  
      } catch (err) {
        dispatch({ type: REGISTER_FAIL, payload: i18n.t('somethingWentWrong') });
      }
  };
};
